import {z} from 'zod';

import {ErrorSchema} from '@dms/api/shared';

// CreateInsuranceDraftResponseBody
export const CreateInsuranceDraftResponseBodySchema = z.object({
  url: z.string(),
});

// InsuranceSpecificationsInsuranceResponseBody
export const InsuranceSpecificationsInsuranceResponseBodySchema = z.object({
  commissionFull: z.number().nullable(),
  commissionYearly: z.number().nullable(),
  insurance: z.number().nullable(),
  insuranceWithDiscount: z.number().nullable(),
  type: z.string().nullable(),
});

// InsuranceSpecificationsResponseBody
export const InsuranceSpecificationsResponseBodySchema = z.object({
  insurance: InsuranceSpecificationsInsuranceResponseBodySchema,
  userRole: z.string().nullable(),
});

// CreateInsuranceDraftApiArg
export const CreateInsuranceDraftApiArgSchema = z.object({
  businessCaseId: z.string(),
});

// GetInsuranceSpecificationsApiArg
export const GetInsuranceSpecificationsApiArgSchema = z.object({
  businessCaseId: z.string(),
});

// Final aliases
export type CreateInsuranceDraftResponseBody = z.infer<
  typeof CreateInsuranceDraftResponseBodySchema
>;
export type Error = z.infer<typeof ErrorSchema>;
export type InsuranceSpecificationsInsuranceResponseBody = z.infer<
  typeof InsuranceSpecificationsInsuranceResponseBodySchema
>;
export type InsuranceSpecificationsResponseBody = z.infer<
  typeof InsuranceSpecificationsResponseBodySchema
>;
export type CreateInsuranceDraftApiArg = z.infer<typeof CreateInsuranceDraftApiArgSchema>;
export type GetInsuranceSpecificationsApiArg = z.infer<
  typeof GetInsuranceSpecificationsApiArgSchema
>;
export type GetInsuranceSpecificationsApiResponse =
  /** status 200  */ InsuranceSpecificationsResponseBody;
export type CreateInsuranceDraftApiResponse = /** status 200  */ CreateInsuranceDraftResponseBody;
